"use client";

import { createPortal } from "react-dom";
import { ToastContainer as ReactToastContainer } from "react-toastify";
import { useIsMounted } from "../../hooks/useIsMounted";
import { classNames } from "../../utils/classNames";

const TOAST_SURFACE_CLASSES =
	"pointer-events-auto mb-4 flex w-full max-w-md gap-2 rounded-lg bg-neutral shadow-lg before:pointer-events-none";

type ToastContainerProps = {
	className?: string;
};

export const ToastContainer = ({ className }: ToastContainerProps) => {
	const isMounted = useIsMounted();

	if (!isMounted) {
		return null;
	}

	return createPortal(
		<ReactToastContainer
			stacked
			icon={false}
			closeButton={false}
			hideProgressBar={true}
			draggable={false}
			autoClose={6_000}
			closeOnClick={false}
			toastClassName={() => TOAST_SURFACE_CLASSES}
			className={classNames("z-toast", className)}
		/>,
		document.body,
	);
};
